<template>
  <div>
    <div class="row p-0 m-0">
      <div class="col-sm-12 col-xs-12 billing-wrapper">
        <div class="col-xs-12 col-sm-12">
          <div class="col-xs-12 col-sm-12 billing-info-title-section">
            <h3 class="billing-info-title">{{ $t('billingInformation')}}</h3>
          </div>
        </div>
        <div class="col-sm-12 col-xs-12 pl-27 pr-55">
          <div class="col-sm-6 col-md-6 col-xs-12 form-group">
            <div class="col-sm-12 col-xs-12 label_name asterisk">{{$t('firstName')}}</div>
            <div class="col-sm-12 col-xs-12 field-section right">
              <input
                type="text"
                :placeholder="$t('enterFirstName')"
                class="form-control"
                maxlength="35"
                v-model.trim="companyData.first_name"
                name="first_name"
                @keyup="checkUpdatedFields($event)"
                :class="$v.companyData.first_name.$error ? 'invalid-border' : ''"
                @blur="$v.companyData.first_name.$touch()"
              />
              <div v-if="$v.companyData.first_name.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.first_name.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-class"
                  v-else-if="!$v.companyData.first_name.minLength"
                >{{$t('min2CharactersRequired')}}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xs-12 form-group">
            <div class="col-sm-12 col-xs-12 label_name asterisk ml-22">{{$t('lastName')}}</div>
            <div class="col-sm-12 col-xs-12 field-section left">
              <input
                type="text"
                :placeholder="$t('enterLastName')"
                class="form-control"
                maxlength="30"
                v-model.trim="companyData.last_name"
                name="last_name"
                @keyup="checkUpdatedFields($event)"
                :class="$v.companyData.last_name.$error ? 'invalid-border' : ''"
                @blur="$v.companyData.last_name.$touch()"
              />
              <div v-if="$v.companyData.last_name.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.last_name.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-class"
                  v-else-if="!$v.companyData.last_name.minLength"
                >{{$t('min2CharactersRequired')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xs-12 pl-27 pr-55">
          <div class="col-sm-6 col-md-6 col-xs-12 form-group">
            <div class="col-sm-12 col-xs-12 label_name asterisk">{{$t('email')}}</div>
            <div class="col-sm-12 col-xs-12 field-section right">
              <input
                type="text"
                :placeholder="$t('enterEmail')"
                class="form-control"
                maxlength="65"
                :class="{'invalid-border': $v.companyData.email.$error || displayEmailErrorMsg }"
                v-model.trim="companyData.email"
                name="email"
                @keyup="checkUpdatedFields($event)"
                @blur="emailVal"
              />
              <div v-if="!loaderStatus && $v.companyData.email.$error">
              <div
                class="custom-error-class"
                v-if="!$v.companyData.email.required"
                >{{$t('completeRequiredField')}}</div>
              </div>
              <div v-else-if="displayEmailErrorMsg" class="custom-error-class">
                {{$t('invalidEmailEntry')}}
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xs-12 form-group">
            <div class="col-sm-12 col-xs-12 label_name asterisk ml-22">{{ $t('phoneNumber')}}</div>
            <div class="col-sm-12 col-xs-12 field-section left">
              <input
                type="text"
                :placeholder="$t('enterPhoneNumber')"
                class="form-control"
                maxlength="20"
                v-model.trim="companyData.phone"
                name="phone"
                @keyup="checkUpdatedFields($event)"
                :class="$v.companyData.phone.$error ? 'invalid-border' : ''"
                @blur="$v.companyData.phone.$touch()"
              />
              <div v-if="$v.companyData.phone.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.phone.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-class"
                  v-else-if="!$v.companyData.phone.isNumber && $v.companyData.phone.$error"
                >{{$t('enterOnlyNumbers')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xs-12 pl-27 pr-55">
          <div class="col-sm-6 col-md-6 col-xs-12 form-group">
            <div class="col-sm-12 col-xs-12 label_name asterisk">{{ $t('streetAddress')}}</div>
            <div class="col-sm-12 col-xs-12 field-section right">
              <input
                type="text"
                :placeholder="$t('enterStreetAddress')"
                class="form-control"
                size="60"
                v-model.trim="companyData.street_address"
                name="street_address"
                @keyup="checkUpdatedFields($event)"
                :class="$v.companyData.street_address.$error ? 'invalid-border' : ''"
                @blur="$v.companyData.street_address.$touch()"
              />
              <div v-if="$v.companyData.street_address.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.street_address.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.street_address.isAllowedCharacters && $v.companyData.street_address.$error"
                >{{ specialCharacterErrMsg }}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xs-12 form-group">
            <div class="col-sm-12 col-xs-12 label_name asterisk ml-22">{{$t('city')}}</div>
            <div class="col-sm-12 col-xs-12 field-section left">
              <input
                type="text"
                :placeholder="$t('enterCity')"
                class="form-control"
                maxlength="50"
                size="60"
                v-model.trim="companyData.card_city"
                name="card_city"
                @keyup="checkUpdatedFields($event)"
                :class="$v.companyData.card_city.$error ? 'invalid-border' : ''"
                @blur="$v.companyData.card_city.$touch()"
              />
              <div v-if="$v.companyData.card_city.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.card_city.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.card_city.minLength"
                >{{$t('min3CharactersRequired')}}.</div>
                <div
                  class="custom-error-class"
                  v-else-if="!$v.companyData.card_city.isAllowedCharacters"
                >{{ specialCharacterErrMsg }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xs-12 pl-27 pr-55">
          <div class="col-sm-6 col-md-6 col-xs-12 form-group">
            <div class="col-sm-12 col-xs-12 label_name asterisk">{{$t('state')}}</div>
            <div class="col-sm-12 col-xs-12 field-section right">
              <input
                type="text"
                :placeholder="$t('enterState')"
                class="form-control"
                maxlength="50"
                size="60"
                v-model.trim="companyData.card_state"
                name="card_state"
                @keyup="checkUpdatedFields($event)"
                :class="$v.companyData.card_state.$error ? 'invalid-border' : ''"
                @blur="$v.companyData.card_state.$touch()"
              />
              <div v-if="$v.companyData.card_state.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.card_state.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.card_state.isAllowedCharacters && $v.companyData.card_state.$error"
                >{{ specialCharacterErrMsg }}</div>
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.card_state.isText && $v.companyData.card_state.$error"
                >{{$t('invalidFormat')}}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-xs-12 form-group">
            <div class="col-sm-12 col-xs-12 label_name asterisk ml-22">{{$t('postCode')}}</div>
            <div class="col-sm-12 col-xs-12 field-section left">
              <input
                type="text"
                :placeholder="$t('enterPostCode')"
                class="form-control"
                maxlength="15"
                v-model.trim="companyData.card_postal"
                name="card_postal"
                @keyup="checkUpdatedFields($event)"
                :class="$v.companyData.card_postal.$error ? 'invalid-border' : ''"
                @blur="$v.companyData.card_postal.$touch()"
              />
              <div v-if="$v.companyData.card_postal.$error">
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.card_postal.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-class"
                  v-if="!$v.companyData.card_postal.minLength"
                >{{$t('min2CharactersRequired')}}.</div>
                <div
                  class="custom-error-class"
                  v-else-if="!$v.companyData.card_postal.isPostalCode && companyData.card_postal"
                >{{$t('validZipRequired')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-xs-12 pl-27 pr-55">
          <div class="col-sm-6 col-md-6 col-xs-12 form-group">
            <div class="col-sm-12 col-xs-12 label_name asterisk">{{$t('country')}}</div>
            <div class="col-sm-12 col-xs-12 field-section right">
              <multiselect
                class="product-class-ellipsis multiselect-single-dropdown mb-38"
                :placeholder="$t('selectACountry')"
                label="country_name"
                :showLabels="false"
                openDirection="below"
                v-model="companyData.country_name"
                :options="countryList.map(type => type.country_name)"
                :custom-label="opt => customLabels(opt)"
              >
              <span slot="noResult">{{ $t('noElementsFound') }}</span>
              </multiselect>
              <div v-if="$v.companyData.country_name.$error">
                <div
                  class="custom-error-class pt-48"
                  v-if="!$v.companyData.country_name.required && $v.companyData.country_name.$error"
                >{{$t('completeRequiredField')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-12 footer_buttons">
      <div class="col-md-6 col-xs-6 col-sm-6  footer_left_button">
        <button type="button" class="btn btn-block blue_outline_back_button" @click="backToPaymentMethod">{{$t('back')}}</button>
      </div>
      <div class="col-xs-6 footer_right_buttons_section">
            <button type="button" class="btn btn-block blue_outline_cancel_button" @click="cancelBillingInformationUpdate">{{$t('cancel')}}</button>
            <button
              type="button"
              class="blue_save_changes_button"
              @click="saveBillingDetails"
              :disabled="disableBillingInformationButton"
            >{{$t('save')}}</button>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
    <div id="confirmPopup" class="modal fade" role="dialog">
      <div class="modal-dialog profile-confirm-poup">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header confirmpopup-bgcolor">
            <button
              type="button"
              class="close"
              data-toggle="modal"
              data-target="#confirmPopup"
            >&times;</button>
          </div>
          <div
            class="modal-body confirm-body"
          >{{ $t('saveChangesMessage')}}</div>
          <div class="modal-footer confirmpopup-bgcolor">
            <div class="col-md-6 col-sm-6 col-xs-12 profile-footer-save">
              <button
                type="button"
                class="btn btn-block save-changes"
                @click="confirmChanges"
              >{{ $t('saveChanges')}}</button>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
              <button
                type="button"
                class="btn btn-block discard-changes"
                @click="cancelConfirmPopUp"
              >{{ $t('discardChanges')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { isEqual } from 'lodash';
import { required, minLength } from 'vuelidate/lib/validators';
import {
  isNumber,
  isAllowedCharacters,
  isPostalCode,
  isText
} from '../../Register/validator';
import { getAllCountries } from '../../../apis/countriesList';
import { updateBillingInfo } from '../../../apis/psm';

import Loader from '../../UIComponents/Loader.vue';
import EventBus from '../../../utils/event-bus';

export default {
  props: ['userAndCompanyData', 'id', 'fromDetails'],
  data() {
    return {
      countryList: [],
      loaderStatus: false,
      disableBillingInformationButton: true,
      displayEmailErrorMsg: false,
      getBillingInfoData: '',
      response: '',
      currentTargetedField: '',
      companyData: {},
      specialCharacterErrMsg: 'The following characters are not allowed: * ? < > ! @ # $ “ % ^',
      update_type: '',
      paymentIdFromPaymentMethod: null,
    };
  },
  validations: {
    companyData: {
      first_name: {
        minLength: minLength(2),
        required,
      },
      last_name: {
        minLength: minLength(2),
        required,
      },
      email: {
        required,
      },
      phone: {
        required,
        isNumber,
      },
      street_address: {
        required,
        isAllowedCharacters,
      },
      card_city: {
        minLength: minLength(3),
        required,
        isAllowedCharacters,
      },
      card_state: {
        required,
        isAllowedCharacters,
        isText,
      },
      card_postal: {
        minLength: minLength(2),
        required,
        isPostalCode,
      },
      country_name: {
        required,
      },
    },
  },
  components: {
    Loader,
  },
  methods: {
    customLabels(opt) {
      const option = this.countryList.find((x) => x.country_name === opt);
      if (option && Object.keys(option) && Object.keys(option).length) {
        return option.country_name;
      }
      return '';
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    async confirmChanges() {
      $('#confirmPopup').modal('toggle');
      await this.saveBillingDetails();
      this.$emit('cancelBillingInformationUpdate');
    },
    cancelConfirmPopUp() {
      this.disableBillingInformationButton = true;
      $('#confirmPopup').modal('toggle');
      this.$emit('cancelBillingInformationUpdate');
    },
    toggleConfirmPopUp() {
      $('#confirmPopup').modal('toggle');
    },
    backToPaymentMethod() {
      if (this.fromDetails.fromPage === 'paymentMethod') {
        this.$emit('backToPaymentMethod', { paymentId: this.fromDetails.paymentId });
      } else {
        this.cancelBillingInformationUpdate();
      }
    },
    cancelBillingInformationUpdate() {
      if (!this.disableBillingInformationButton) {
        this.$emit('closepopup');
      } else {
        this.companyData = {};
        this.$emit('cancelBillingInformationUpdate');
      }
    },
    emailVal() {
      this.$v.companyData.email.$touch();
      const mailformat = /^([a-zA-Z0-9_\-\+\.]+)@([a-zA-Z-0-9-]+)((\.([a-zA-Z0-9-]){2,63}){1,3})$/; //eslint-disable-line
      this.displayEmailErrorMsg = false;
      if (this.companyData.email && !this.companyData.email.match(mailformat)) {
        this.displayEmailErrorMsg = true;
        return true;
      }
      return false;
    },
    checkUpdatedFields(event) {
      if (event.currentTarget) {
        this.currentTargetedField = event.currentTarget.name;
      } else if (event === 'country_name') {
        this.currentTargetedField = this.companyData.country_name;
      }
      const response = JSON.parse(localStorage.getItem('previouscompanyData'));
      if (this.companyData.first_name === '' || this.companyData.last_name === '' || this.companyData.email === '' || this.companyData.phone === ''
        || this.companyData.street_address === '' || this.companyData.card_city === '' || this.companyData.card_state === ''
        || this.companyData.card_postal === '' || this.companyData.country_name === '') {
        this.disableBillingInformationButton = true;
        return;
      }
      if (this.currentTargetedField === 'email') {
        if (this.emailVal) {
          this.disableBillingInformationButton = true;
          return;
        }
        this.disableBillingInformationButton = false;
      }
      if (this.$v.companyData.$invalid) {
        this.disableBillingInformationButton = true;
        return;
      }
      if (!isEqual(response, this.companyData)) {
        this.disableBillingInformationButton = false;
        return;
      }
      this.disableBillingInformationButton = true;
    },
    async saveBillingDetails() {
      this.loaderStatus = true;
      const companyData = {
        first_name: this.companyData.first_name,
        last_name: this.companyData.last_name,
        email: this.companyData.email,
        phone: this.companyData.phone,
        street_address: this.companyData.street_address,
        card_city: this.companyData.card_city,
        card_state: this.companyData.card_state,
        card_postal: this.companyData.card_postal,
        country_name: this.companyData.country_name,
        id: '',
      };
      if (this.fromDetails.fromPage === 'paymentMethod') {
        this.update_type = 'changePaymentMethod';
      } else {
        this.update_type = 'profile_billing_page';
        companyData.id = this.id;
      }
      const fields = { ...companyData, update_type: this.update_type, payment_method_id: this.paymentIdFromPaymentMethod };
      const response = await updateBillingInfo(fields);
      this.disableBillingInformationButton = true;
      this.loaderStatus = false;

      if (response) {
        if (response.status !== 204) {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: this.$i18n.locale === 'Portuguese' ? 'Falha na atualização das informações de faturamento.' : 'Billing info updation failed.',
            group: 'custom-notification',
          });
        } else {
          this.clearNotifcations();
          this.$notify({
            type: 'success',
            title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
            text: this.$i18n.locale === 'Portuguese' ? 'Informações de faturamento atualizadas.' : 'Billing info updated.',
            group: 'custom-notification',
          });
          this.$emit('cancelBillingInformationUpdate');
          EventBus.$emit('navigateToConfirmPageInCart');
          // this.$router.push({ name: 'ViewCart', params: { from: 'billingInfoInAccountSettings' } });
        }
      } else {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Falha na atualização das informações de faturamento.' : 'Billing info updation failed.',
          group: 'custom-notification',
        });
      }
    },
  },
  watch: {
    'companyData.country_name'() { //eslint-disable-line
      this.checkUpdatedFields('country_name');
    },
  },
  async created() {
    this.loaderStatus = true;
    this.countryList = await getAllCountries();
    this.paymentIdFromPaymentMethod = this.fromDetails.paymentId;
    this.loaderStatus = false;
  },
};
</script>
<style scoped>
.multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
}
.product-class-ellipsis.multiselect-single-dropdown
>>> .multiselect__single,
.accredited-by-ellipsis.multiselect-single-dropdown
>>> .multiselect__single{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 450px;
  margin-bottom: 0px;
}
.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 44px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 34px;
    padding: 3px 40px 6px 11px;
    border: 1px solid #4D4D4D !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 7px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top:8px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;

  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;

  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #999999;
    overflow: visible;
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
.pl-27{
  padding-left: 27px;
}
.pr-55{
  padding-right: 55px;
}
.billing-wrapper {
  overflow: auto;
  margin-bottom: 10px;

}
.ml-22{
  margin-left: 16px;
}
.profile-confirm-poup {
  width: 500px;
}
.modal-header .close {
  background: unset;
  opacity: 1;
  line-height: unset;
  width: unset;
  border-radius: unset;
  color: unset;
  font-weight: 300;
  font-size: 30px;
}
.confirmpopup-bgcolor {
  background-color: #ffffff;
  border: 0px;
  border-radius: 10px;
}
.confirm-body {
  padding: 5% 12%;
  margin-bottom: 10%;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #333333;
}
.profile-footer-save {
  float: right;
}
.invalid-border {
  border-color: #a20000 !important;
}
.custom-error-class{
  margin-top: 0px;
  margin-bottom: 5px;
  color: #E12D33;
  list-style-type: none;
  display: block;
  padding-top: 12px;
  font-size: 14px;
}
/* @media screen and (min-width: 1301px) AND (max-height: 430px) {
  .billing-wrapper {
      max-height: calc(83vh - 142px);
  }
} */
.billing-wrapper::-webkit-scrollbar {
  width: 6px;
}
.billing-wrapper::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  height: 30%;
}
.billing-info-title-section{
  padding-left: 4px;
}
.billing-info-title{
  margin-top: 0px;
  margin-bottom: 32px;
  font-weight: 600;
  font-size: 18px;
  color: #333;
}
.form-group{
  padding-left: 0px;
  padding-right: 0px;
  margin-bottom: 32px;
}
.form-group ::placeholder {
  color: #999999;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
}
.form-group .label_name{
  padding-left: 0px;
  margin-bottom: 7px;
  font-size: 16px;
  color: #3e3e3e;
}
.mb-44{
  margin-bottom: 44px;
}
.form-control::placeholder {
  color:  #999999;
}
.form-group input{
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #4d4d4d;
  padding-left: 12px;
  padding-top: 6px;
  padding-bottom: 5px;
  border: 1px solid #4D4D4D;
  border-radius: 3px;
  display: block;
  width: 100%;
  height: 34px;
  background-color: #fff !important;
}
.asterisk:after {
    content: '*';
    font-size: 16px;
    color: #C02032;
    position: relative;
    top: -1px;
    margin-left: 4px;
}
/* Country Multiselect Styles */

  /* Footer buttons section  */
  .footer_buttons {
  padding-bottom: 24px;
  right: 0px;
  background-color: #fff;
  }
  .footer_left_button{
  display: flex;
  /* padding-left:30px; */
  align-items: center;
  justify-content: flex-start;
  z-index: 100;
  background: #ffffff;
  padding-top: 10px;
}
.blue_outline_back_button, .blue_outline_back_button:hover{
    background-color: #ffffff;
    border: 1px solid #000001;
    height: 44px;
    width: auto;
    color: #000;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    padding: 9px 16px !important;

}
.footer_right_buttons_section{
  display:flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 16px;
  background: #ffffff;
  padding-top: 10px;
  padding-right: 10px;
}
.blue_outline_cancel_button, .blue_outline_cancel_button:hover{
    background-color: #E6E6E6;
    border: none;
    height: 44px;
    width: auto;
    color: #404040;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    padding: 10px 16px !important

}
.blue_save_changes_button, .blue_save_changes_button:hover{
    background-color: #01518a;
    border: none;
    height: 44px;
    cursor: pointer;
    min-width: 73px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    border-radius: 3px;
    margin-top: 0px !important;
    padding: 10px 16px !important
    /* box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25); */
    /* z-index: 100; */
}
.footer_right_buttons_section button:disabled{
  cursor: not-allowed;
  opacity: 0.5;
}
@media (max-width: 1300px){
  .footer_buttons{
    padding-left: 15px !important;
  }
}
@media screen and (max-width: 600px) {
  .footer_buttons{
    display:flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 15px;
    width: 100%;
  }
  .footer_right_buttons_section,
  .footer_left_button {
    flex-direction: column;
    row-gap: 15px;
    width: 100%;
  }
  .blue_outline_back_button,
  .blue_outline_cancel_button,
  .blue_save_changes_button{
    width: 100%;
  }
}
@media (min-width: 768px) {
  .form-group .field-section.left {
    padding-right: 0px;
    padding-left: 16px;
  }
  .form-group .field-section.right{
    padding-right: 15px;
    padding-left: 0px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .billing-wrapper {
    height: 65vh;
  }
}
/* iphoneX landscape  */
@media (device-width: 812px) and (device-height: 375px){
  .billing-wrapper {
    height: 52vh;
  }
}
/* iphone5 landscape and below */
@media (max-width: 640px) and (max-height: 360px){
  .billing-wrapper {
    height: 45vh;
  }
}
/* iphone 6 and 6+ landscape  */
@media (device-width: 736px) and (device-height: 414px), (device-width: 667px) and (device-height: 375px){
  .billing-wrapper {
    height: 48vh;
  }
}
/* @media (min-width: 1025px) and (max-width: 1280px) {
  .form-group input {
      padding: 0px;
  }
} */
@media (min-width: 1898px) {
  .footer_buttons {
    position: absolute;
    bottom: 24px;
    padding-bottom: 0px;
  }
}
</style>
